<template>
  <v-card v-if="loading">
    <v-skeleton-loader type="image" />
  </v-card>

  <v-card v-else flat class="card-appointments d-flex">
    <v-card-text>
      <div v-if="isEmpty">
        <p>{{ $t('honda.dashboard.stats.no-data') }}</p>
      </div>

      <div v-else class="card-body">
        <div>
          <p class="metric-title">{{ title }}</p>
          <p class="metric-value">{{ current }}</p>
        </div>

        <div v-if="current !== 0" class="details">
          <div class="alert">
            <v-icon size="14" color="#dc182d">fa-light fa-triangle-exclamation</v-icon>
            <p class="alert-text">{{ $t('honda.dashboard.stats.appointments.remember-accept') }}</p>
          </div>

          <router-link :to="{name: 'Revisions'}">
            <button>{{ $t('honda.dashboard.stats.appointments.management') }}</button>
          </router-link>

          <p class="message">{{ $t('honda.dashboard.stats.appointments.confirmation') }}</p>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import {computed, defineComponent, toRefs} from '@vue/composition-api'

export default defineComponent({
  name: 'CardAppointments',
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    current: {
      type: Number,
      required: false,
    },
  },
  setup(props) {
    const {current} = toRefs(props)

    const isEmpty = computed(() => {
      return !current?.value && current?.value !== 0
    })

    return {
      isEmpty,
    }
  },
})
</script>

<style>
.v-skeleton-loader__image {
  height: 270px;
}
</style>

<style lang="scss" scoped>
.card-appointments {
  width: 100%;
  height: 270px;
  border-radius: 6px !important;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16) !important;
  font-family: 'Roboto', serif;
  overflow: hidden;
}

.card-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.metric-title {
  color: #222;
  font-family: 'ProximaNovaExCnSBold', system-ui, sans-serif;
  font-size: 20px;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.metric-value {
  display: block;
  color: #222;
  font-family: 'ProximaNovaSemibold', system-ui, sans-serif;
  font-size: 32px;
  line-height: 1;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.details {
  margin-top: 25px;

  button {
    background-color: #dc182d;
    border-radius: 20px;
    color: antiquewhite;
    width: 100%;
    padding: 0 !important;
    margin-bottom: 8px;
  }
}

.alert {
  display: flex;
  align-items: center;
  background-color: #ffbfbf;
  padding: 7px;
  justify-content: center;
  border-radius: 5px;
  margin-bottom: 8px;

  .alert-text {
    margin: 0;
    margin-left: 5px;
    color: #dc182d;
    font-size: 11px;
    font-family: 'ProximaNovaSemibold';
    line-height: 1.1;
  }
}

.message {
  color: #999;
  font-size: 11px;
  font-family: 'ProximaNovaRegular';
  line-height: 1.1;
  margin: 0;
  text-align: center;
}
</style>
